module.exports = __webpack_public_path__ + "img/eres_8_steps_es.bd7ad9d3.jpg";